import pdfLogo from '../../public/images/pdf-logo-256x256.png';
import wordLogo from '../../public/images/doc-logo-256x256.png';
import excelLogo from '../../public/images/excel-logo-256x256.png';
import pptLogo from '../../public/images/ppt-logo-256x256.png';
import txtLogo from '../../public/images/txt-logo-256x256.png';
import otherLogo from '../../public/images/file_other-logo-256x256.png';
import imgLogo from '../../public/images/img-logo-256x256.png';

export const translationSuffixes = {
	placeholder: '.placeholder',
	label: '.label',
	tooltip: '.tooltip'
};

export const dir = {
	left: 'left',
	right: 'right'
};

export const fileThumbnailType = {
	word:         	wordLogo,
	excel: 					excelLogo,
	text:         	txtLogo,
	pdf:          	pdfLogo,
	powerpoint:     pptLogo,
	image:        	imgLogo,
	unknown:        otherLogo
};

export const ALL_SELECTED = 'ALL_SELECTED';
